<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                color="success"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                @click="
                  printAllStockValuationReport('printStockValuationReport')
                "
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllStockValuation()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>
            Filter<v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                v-model="queryParams.productCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Product Name"
                type="text"
                v-model="queryParams.productName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="warehouseList"
                label="Warehouse"
                v-model="queryParams.warehouseId"
                :readonly="
                  user.role.roleName == 'BRANCH_ADMIN' ||
                  user.role.roleName == 'WAREHOUSE_MANAGER'
                "
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="categoryList"
                label="Category"
                v-model="queryParams.categoryId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="brandList"
                label="Brand"
                v-model="queryParams.brandId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="productGroupList"
                label="ProductGroup"
                v-model="queryParams.productGroupId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="priceTypeList"
                label="Type"
                v-model="queryParams.priceType"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                :items="balanceTypeList"
                label="Balance"
                v-model="queryParams.balanceType"
                item-text="text"
                item-value="value"
                menu-props="auto"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card class="font-weight-bold">
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Amount :</span>
              <v-chip>
                <span>{{ totalAmount | decFormat(6) }}</span>
              </v-chip>
              <span>Total Qty :</span>
              <v-chip>
                <span>{{ totalQty | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.warehouseName }}</td>
                <td>{{ props.item.productName }}</td>
                <td>{{ props.item.productGroupName }}</td>
                <td>
                  {{
                    props.item.productCode +
                    "/" +
                    props.item.categoryName +
                    "/" +
                    props.item.brandName
                  }}
                </td>
                <td>{{ props.item.qcNo }}</td>
                <td>{{ props.item.batchNo }}</td>
                <td>
                  {{ props.item.expDateInMilliSeconds | formatMsDate }}
                </td>
                <td>
                  {{ props.item.mfgDateInMilliSeconds | formatMsDate }}
                </td>
                <td
                  style="text-align: right"
                  v-if="queryParams.priceType == 'Unit Cost'"
                >
                  {{ props.item.unitCost | decFormat(6) }}
                </td>
                <td
                  style="text-align: right"
                  v-else-if="queryParams.priceType == 'Selling Price'"
                >
                  {{ props.item.sellingPrice | decFormat(6) }}
                </td>
                <td
                  v-else-if="
                    queryParams.priceType == 'Unit Cost With Item Percent'
                  "
                >
                  {{ props.item.unitCostwithPercent | decFormat(6) }}
                </td>
                <td
                  v-else-if="queryParams.priceType == 'Weighted Average Cost'"
                >
                  {{ props.item.wacCost | decFormat(6) }}
                </td>
                <td>{{ props.item.qtyStr }}</td>
                <td>{{ props.item.qty | decFormat(6) }}</td>
                <td
                  style="text-align: right"
                  v-if="queryParams.priceType == 'Unit Cost'"
                >
                  {{ (props.item.unitCost * props.item.qty) | decFormat(6) }}
                </td>
                <td
                  style="text-align: right"
                  v-else-if="queryParams.priceType == 'Selling Price'"
                >
                  {{
                    (props.item.sellingPrice * props.item.qty) | decFormat(6)
                  }}
                </td>
                <td
                  style="text-align: right"
                  v-else-if="
                    queryParams.priceType == 'Unit Cost With Item Percent'
                  "
                >
                  {{
                    (props.item.unitCostwithPercent * props.item.qty)
                      | decFormat(6)
                  }}
                </td>
                <td
                  style="text-align: right"
                  v-else-if="queryParams.priceType == 'Weighted Average Cost'"
                >
                  {{ (props.item.wacCost * props.item.qty) | decFormat(6) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printStockValuationReport"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Stock Valuation Report</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">Report Date : [{{ date }}]</p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Warehouse
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th
                style="border: 1px solid black; text-align: center"
                v-if="
                  queryParams.priceType == 'Unit Cost' ||
                  queryParams.priceTyep == 'Weighted Average Cost'
                "
              >
                Unit Cost
              </th>
              <th
                style="border: 1px solid black; text-align: center"
                v-else-if="queryParams.priceType == 'Selling Price'"
              >
                Selling Price
              </th>
              <th style="border: 1px solid black; text-align: center" v-else>
                Unit Cost(%)
              </th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
              <th style="border: 1px solid black; text-align: center">
                Basic Qty
              </th>
              <th style="border: 1px solid black; text-align: center">
                Total Amount
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(header, index) in allStockValuationReportList"
            :key="index"
          >
            <tr v-for="(item, i) in header.stockValuationList" :key="i">
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ header.warehouseName }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productName }}
              </td>
              <td
                style="border: 1px solid black; text-align: right"
                v-if="queryParams.priceType == 'Unit Cost'"
              >
                {{ item.unitCost | decFormat(6) }}
              </td>
              <td
                style="border: 1px solid black; text-align: right"
                v-else-if="queryParams.priceType == 'Selling Price'"
              >
                {{ item.sellingPrice | decFormat(6) }}
              </td>
              <td
                style="border: 1px solid black; text-align: right"
                v-else-if="
                  queryParams.priceType == 'Unit Cost With Item Percent'
                "
              >
                {{ item.unitCostwithPercent | decFormat(6) }}
              </td>
              <td
                style="border: 1px solid black; text-align: right"
                v-else-if="queryParams.priceType == 'Weighted Average Cost'"
              >
                {{ item.wacCost | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qtyStr }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qty | decFormat(6) }}
              </td>
              <td
                style="border: 1px solid black; text-align: right"
                v-if="queryParams.priceType == 'Unit Cost'"
              >
                {{ (item.unitCost * item.qty) | decFormat(6) }}
              </td>
              <td
                style="border: 1px solid black; text-align: right"
                v-else-if="queryParams.priceType == 'Selling Price'"
              >
                {{ (item.sellingPrice * item.qty) | decFormat(6) }}
              </td>
              <td
                style="border: 1px solid black; text-align: right"
                v-else-if="
                  queryParams.priceType == 'Unit Cost With Item Percent'
                "
              >
                {{ (item.unitCostwithPercent * item.qty) | decFormat(6) }}
              </td>
              <td
                style="border: 1px solid black; text-align: right"
                v-else-if="queryParams.priceType == 'Weighted Average Cost'"
              >
                {{ (item.wacCost * item.qty) | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="5"
              >
                Sub Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ header.totalQty | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ header.totalAmount | decFormat(6) }}
              </td>
            </tr>
          </tbody>
          <tr>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
              colspan="5"
            >
              Grand Total
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ totalQty | decFormat(6) }}
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ totalAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { stockService } from "../../services/stock-service";
import { categoryService } from "../../services/category-service";
import { brandService } from "../../services/brand-service";
import { warehouseService } from "../../services/warehouse-service";
import { productGroupService } from "../../services/product-group-service";

export default {
  name: "StockValuationReport",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    show: false,
    showFilters: false,
    date: commonService.formatDate(new Date(), "DD/MM/YY"),
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Purchase Reports",
        disabled: true,
      },
      {
        text: "Stock Valuation Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Warehouse", align: "left", value: "w.name", sortable: true },
      { text: "Product Name", value: "p.name", sortable: true },
      { text: "Product Group", sortable: false },
      { text: "Code/Category/Brand", sortable: false },
      { text: "QC No", value: "qcNo", sortable: false },
      { text: "Batch No", value: "batchNo", sortable: false },
      { text: "Exp Date", value: "expDateInMilliSeconds", sortable: false },
      { text: "Mfg Date", value: "mfgDateInMilliSeconds", sortable: false },
      { text: "Unit Cost/Selling Price", sortable: false },
      { text: "Qty", value: "qty" },
      { text: "Basic Qty", sortable: false },
      { text: "Total Amount", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "w.name",
      totalItems: 0,
    },
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    priceTypeList: [
      { label: "Unit Cost", value: "Unit Cost" },
      { label: "Selling Price", value: "Selling Price" },
      {
        label: "Unit Cost With Item Percent",
        value: "Unit Cost With Item Percent",
      },
      { label: "Weighted Average Cost", value: "Weighted Average Cost" },
    ],
    balanceTypeList: [
      { text: "ALL", value: "" },
      { text: "With Balance", value: "WITHBALANCE" },
      { text: "Without Balance", value: "WITHOUTBALANCE" },
    ],
    queryParams: {
      productCode: "",
      productName: "",
      categoryId: "",
      brandId: "",
      warehouseId: "",
      productGroupId: "",
      status: "ACTIVE",
      priceType: "",
      balanceType: "",
    },
    showListLoading: false,
    buttonLoading: false,
    warehouseList: [],
    categoryList: [],
    productGroupList: [],
    brandList: [],
    stockList: [],
    allStockValuationReportList: [],
    totalRows: 0,
    totalQty: 0,
    totalAmount: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockValuationReport();
      },
      deep: true,
    },
  },

  created() {
    if (
      this.user.role.roleName == "BRANCH_ADMIN" ||
      this.user.role.roleName == "WAREHOUSE_MANAGER"
    ) {
      this.queryParams.warehouseId = this.user.warehouseId;
    }
    this.queryParams.status = "ACTIVE";
    this.queryParams.priceType = "Unit Cost With Item Percent";
    //for deep linking
    if (this.$route.query.productCode) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.productName) {
      this.queryParams.productName = this.$route.query.productName;
    }
    if (this.$route.query.categoryId) {
      this.queryParams.categoryId = this.$route.query.categoryId;
    }
    if (this.$route.query.brandId) {
      this.queryParams.brandId = this.$route.query.brandId;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.priceType) {
      this.queryParams.priceType = this.$route.query.priceType;
    }
    if (this.$route.query.balanceType) {
      this.queryParams.balanceType = this.$route.query.balanceType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getWarehouseList();
    this.getBrandList();
    this.getCategoryList();
    this.getProductGroupList();
    this.getStockValuationReportSummary();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-valuation-report",
        query: this.queryParams,
      });
      this.getStockValuationReport();
      this.getStockValuationReportSummary();
    },
    printAllStockValuationReport(divName) {
      this.buttonLoading = true;
      this.getStockValuationReportSummary().then(() => {
        this.allStockValuationReportList = [];
        stockService
          .getAllStockValuationReport(this.queryParams)
          .then((res) => {
            if (res.data) {
              this.allStockValuationReportList =
                res.data.stockValuationReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            var printContents = document.getElementById(divName).innerHTML;
            var reprintWindow = window.open(
              "",
              "MsgWindow",
              "width=500,height=500"
            );
            reprintWindow.document.write(printContents);
            setTimeout(() => {
              reprintWindow.print();
              reprintWindow.close();
            }, 600);
            this.buttonLoading = false;
          });
      });
    },

    getStockValuationReportSummary() {
      return stockService
        .getStockValuationReportSummary(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.totalQty = res.data.totalQty;
            this.totalAmount = res.data.totalAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getStockValuationReport() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockService
        .getStockValuationReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockList = res.data.stockValuationList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getCategoryList() {
      categoryService
        .getAllCategory()
        .then((res) => {
          this.categoryList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.categoryList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getBrandList() {
      brandService
        .getAllBrand()
        .then((res) => {
          this.brandList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.brandList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getProductGroupList() {
      productGroupService
        .getAllProductGroup()
        .then((res) => {
          this.productGroupList = res.data;
          let findAll = {
            id: "",
            name: "---All---",
          };
          this.productGroupList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportAllStockValuation() {
      this.buttonLoading = true;
      stockService
        .exportStockValuationExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>
